import { useEffect, useRef, useState } from "react";
import { useMutation } from "@apollo/client";
import "../assets/css/BreezeStyles.css";
import { SEND_SINGLE_BREEZE_TRANSACTION } from "../graphql/mutations/breeze";

function BreezePayment() {
  const hasSentInitMessage = useRef(false);
  const hasSubmittedPayment = useRef(false);
  const paymentDataRef = useRef(null);
  const transactionIdRef = useRef(null);
  // const hasFinalizedPayment = useRef(false);
  const breezePageIdRef = useRef(null);

  const [breezeUrl, setBreezeUrl] = useState();

  const [startBreezeTransaction, { loading }] = useMutation(
    SEND_SINGLE_BREEZE_TRANSACTION,
    {
      onCompleted: (data) => {
        const result = data?.startBreezeTransaction;

        setBreezeUrl(result.breezeUrl);
        breezePageIdRef.current = result.breezePageId;
        transactionIdRef.current = result.wcTransactionId;
      },
    },
  );

  // const [finalizeBreezeTransaction] = useMutation(FINALIZE_BREEZE_TRANSACTION, {
  //   onCompleted: (data) => {
  //     const result = data?.finalizeBreezeTransaction;

  //     //  notify parent
  //     window.parent.postMessage(
  //       {
  //         type: "BREEZE_REQUEST",
  //         payload: {
  //           action: "FINALIZED",
  //           wcData: result.wcData,
  //           paymentdata: result.paymentdata,
  //         },
  //       },
  //       "*",
  //     );
  //   },
  // });

  useEffect(() => {
    if (!hasSentInitMessage.current) {
      window.parent.postMessage(
        {
          type: "BREEZE_REQUEST",
          payload: { action: "SendBillingData" },
        },
        "*",
      );

      hasSentInitMessage.current = true;
    }

    const handler = async (event) => {
      const { type } = event.data || {};

      console.log("Breeze - Event Handler");
      if (type === "FROM_PARENT") {
        const { payload } = event.data;

        console.log("Breeze-  FromPaarent", payload);
        if (
          payload?.action === "SendBillingData" &&
          !hasSubmittedPayment.current
        ) {
          hasSubmittedPayment.current = true;

          const billing = payload.data;

          const paymentdata = {
            firstname: billing.firstname,
            lastname: billing.lastname,
            address: billing.address1,
            address2: billing.address2,
            city: billing.city,
            state: billing.state,
            zip: parseInt(billing.zip),
            phone: billing.phone,
            email: billing.email,
            country: "US",
            price: parseInt(billing.price),
            expMonth: 0,
            expYear: 0,
            lastFour: 0,
            processorTransactionId: "0",
            bin: "",
            paymentid: billing.paymentid,
            productid: billing.productid,
            refid: billing.refid,
            shortdescription: billing.shortdescription,
            existingcustomer: billing.existingcustomer,
            referral: billing.referral,
            createdate: billing.createdate,
            ipaddress: billing.ipaddress,
          };

          console.log("paymentData", paymentdata);

          paymentDataRef.current = paymentdata;

          await startBreezeTransaction({
            variables: { paymentdata },
          });
        }

        // if (payload?.action === "BreezePaymentUpdate") {
        //   console.log("Breeze - BreezePaymentUpdate");
        //   if (
        //     paymentDataRef.current &&
        //     breezePageIdRef.current &&
        //     !hasFinalizedPayment.current
        //   ) {
        //     hasFinalizedPayment.current = true;

        //     console.log("Breeze - Finalizing");

        //     await finalizeBreezeTransaction({
        //       variables: {
        //         breezePageId: breezePageIdRef.current,
        //         transactionId: transactionIdRef.current,
        //         paymentdata: paymentDataRef.current,
        //       },
        //     });
        //   }
        // }
      }

      // if (type === "payment-status-change") {
      //   const status = event.data?.data?.status;

      //   if (
      //     status === "PAID" &&
      //     paymentDataRef.current &&
      //     breezePageIdRef.current &&
      //     !hasFinalizedPayment.current
      //   ) {
      //     hasFinalizedPayment.current = true;

      //     await finalizeBreezeTransaction({
      //       variables: {
      //         breezePageId: breezePageIdRef.current,
      //         transactionId: transactionIdRef.current,
      //         paymentdata: paymentDataRef.current,
      //       },
      //     });
      //   }
      // }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [startBreezeTransaction]);

  return (
    <div className="breeze-overlay">
      <div className="breeze-shell">
        {loading && <div className="breeze-loading">Loading payment…</div>}

        {breezeUrl && (
          <iframe
            src={`${breezeUrl}?preferred_payment_methods=card&save_payment_method=false`}
            allow="payment *"
            style={{ width: "100%", height: "100vh", border: 0 }}
            id="breeze-payment-page"
          />
        )}
      </div>
    </div>
  );
}

export default BreezePayment;
